"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NewCactusCartValidation = _interopRequireDefault(require("../default/NewCactusCartValidation"));
var _NewCactusItemModal = _interopRequireDefault(require("../default/NewCactusItemModal"));
var _CommandProductModal = _interopRequireDefault(require("./CommandProductModal"));
var _styles = require("../../styles");
var _newcactusApi = require("../../service/newcactusApi");
var _newcactusMenuUtils = require("../../service/newcactusMenuUtils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const STEPS = {
  CONSUMPTION: 1,
  PRODUCTS: 2,
  RECAP: 3,
  QR_CODE: 4
};
const STEP_LABELS = {
  [STEPS.CONSUMPTION]: 'Mode',
  [STEPS.PRODUCTS]: 'Produits',
  [STEPS.RECAP]: 'Récapitulatif',
  [STEPS.QR_CODE]: 'Paiement'
};
const QR_CODE_SIZE = 280;
const CONSUMPTION_ICONS = {
  default: {
    sur_place: '🍽️',
    emporter: '🥡'
  },
  modern: {
    sur_place: '🍽️',
    emporter: '🥡'
  },
  pizza: {
    sur_place: '🍕',
    emporter: '📦'
  },
  tropical: {
    sur_place: '🏖️',
    emporter: '🌴'
  },
  street: {
    sur_place: '🍔',
    emporter: '🛍️'
  },
  patisserie: {
    sur_place: '☕',
    emporter: '🥐'
  },
  prestige: {
    sur_place: '🍷',
    emporter: '📦'
  },
  neon: {
    sur_place: '🎮',
    emporter: '⚡'
  },
  minimal: {
    sur_place: '🍽️',
    emporter: '🥡'
  },
  demo: {
    sur_place: '✦',
    emporter: '↗'
  },
  latino: {
    sur_place: '🌶️',
    emporter: '🌮'
  }
};
const CommandKioskNewCactusCore = ({
  templateVariant = 'default',
  styles_properties = {},
  scaleFactor = 1,
  className = '',
  style = {},
  onSubmitOrder,
  project_id: projectId,
  logEvent,
  uri_transformer = url => url,
  ...rest
}) => {
  const mergedStyles = (0, _styles.mergeCommandStyles)(templateVariant, styles_properties);
  const labels = (0, _styles.getCommandLabels)(mergedStyles, templateVariant);
  const kioskStyle = (0, _styles.buildCommandKioskStyle)(mergedStyles, scaleFactor, style);
  const newcactusPaymentMethod = mergedStyles.newcactus_payment_method || 'cash';
  const [step, setStep] = (0, _react.useState)(STEPS.CONSUMPTION);
  const [consumptionType, setConsumptionType] = (0, _react.useState)(null);
  const [cart, setCart] = (0, _react.useState)([]);
  const [addedId, setAddedId] = (0, _react.useState)(null);
  const [selectedCategoryId, setSelectedCategoryId] = (0, _react.useState)(null);
  const [customizingItem, setCustomizingItem] = (0, _react.useState)(null);
  const [detailItem, setDetailItem] = (0, _react.useState)(null);
  const [ncConfig, setNcConfig] = (0, _react.useState)(null);
  const [menuRaw, setMenuRaw] = (0, _react.useState)([]);
  const [menuLoading, setMenuLoading] = (0, _react.useState)(false);
  const [menuError, setMenuError] = (0, _react.useState)(null);
  const [checkoutPresentation, setCheckoutPresentation] = (0, _react.useState)({
    mode: 'qr',
    paymentLink: '',
    receiptUrl: '',
    commandId: '',
    paymentIntentId: ''
  });
  const currency = ncConfig?.currency ?? 'RWF';
  const formatPrice = value => (0, _newcactusApi.formatCurrency)(value, currency);
  const categories = (0, _react.useMemo)(() => (0, _newcactusMenuUtils.buildMenuCategories)(menuRaw), [menuRaw]);
  const allMenuItems = (0, _react.useMemo)(() => (0, _newcactusMenuUtils.flattenMenuItems)(menuRaw), [menuRaw]);
  const filteredItems = (0, _react.useMemo)(() => {
    if (!selectedCategoryId) return allMenuItems;
    return allMenuItems.filter(item => item.categoryId === selectedCategoryId);
  }, [allMenuItems, selectedCategoryId]);
  const loadMenuData = (0, _react.useCallback)(async () => {
    if (!projectId) return;
    setMenuLoading(true);
    setMenuError(null);
    try {
      const [config, menuData] = await Promise.all([(0, _newcactusApi.fetchNewCactusConfig)(projectId), (0, _newcactusApi.fetchNewCactusMenu)(projectId)]);
      if (!config?.configured) {
        throw new Error('New Cactus non configuré pour ce projet');
      }
      setNcConfig(config);
      setMenuRaw((0, _newcactusMenuUtils.parseMenuResponse)(menuData));
    } catch (err) {
      setMenuError(err?.message || 'Impossible de charger le menu');
    } finally {
      setMenuLoading(false);
    }
  }, [projectId]);
  (0, _react.useEffect)(() => {
    if (step === STEPS.PRODUCTS && projectId && menuRaw.length === 0 && !menuLoading && !menuError) {
      void loadMenuData();
    }
  }, [step, projectId, menuRaw.length, menuLoading, menuError, loadMenuData]);
  const resetOrder = (0, _react.useCallback)(() => {
    setStep(STEPS.CONSUMPTION);
    setConsumptionType(null);
    setCart([]);
    setCustomizingItem(null);
    setDetailItem(null);
    setCheckoutPresentation({
      mode: 'qr',
      paymentLink: '',
      receiptUrl: '',
      commandId: '',
      paymentIntentId: ''
    });
    onSubmitOrder?.([]);
    logEvent?.({
      type: 'command_reset',
      cell_id: rest.id
    });
  }, [onSubmitOrder, logEvent, rest.id]);
  const addCartLine = (0, _react.useCallback)(line => {
    const lineKey = (0, _newcactusMenuUtils.buildCartLineKey)(line.menuItemId, line.optionIds, line.removedIngredientIds);
    setCart(prev => {
      const existing = prev.find(item => item.lineKey === lineKey);
      const qty = Math.max(1, Number(line.quantity) || 1);
      if (existing) {
        return prev.map(item => item.lineKey === lineKey ? {
          ...item,
          quantity: item.quantity + qty
        } : item);
      }
      return [...prev, {
        lineKey,
        menuItemId: line.menuItemId,
        productName: line.productName,
        unitPrice: line.unitPrice,
        quantity: qty,
        optionIds: line.optionIds ?? [],
        removedIngredientIds: line.removedIngredientIds ?? [],
        optionLabels: line.optionLabels ?? [],
        removedLabels: line.removedLabels ?? [],
        notes: line.notes ?? '',
        categoryName: line.categoryName
      }];
    });
    setAddedId(line.menuItemId);
    logEvent?.({
      type: 'command_add_to_cart',
      cell_id: rest.id,
      add_datas: {
        menu_item_id: line.menuItemId
      }
    });
    setTimeout(() => setAddedId(null), 600);
  }, [logEvent, rest.id]);
  const handleItemClick = (0, _react.useCallback)(item => {
    if ((0, _newcactusMenuUtils.itemNeedsCustomization)(item)) {
      setCustomizingItem(item);
      return;
    }
    addCartLine({
      menuItemId: item.id,
      productName: item.name,
      unitPrice: Number(item.price) || 0,
      optionIds: [],
      removedIngredientIds: [],
      optionLabels: [],
      removedLabels: [],
      notes: '',
      categoryName: item.categoryName
    });
  }, [addCartLine]);
  const updateQuantity = (0, _react.useCallback)((index, delta) => {
    setCart(prev => {
      const item = prev[index];
      const newQty = item.quantity + delta;
      if (newQty <= 0) return prev.filter((_, i) => i !== index);
      return prev.map((it, i) => i === index ? {
        ...it,
        quantity: newQty
      } : it);
    });
  }, []);
  const removeFromCart = (0, _react.useCallback)(index => {
    setCart(prev => prev.filter((_, i) => i !== index));
  }, []);
  const cartTotal = cart.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);
  const handleConsumptionChoice = (0, _react.useCallback)(type => {
    setConsumptionType(type);
    setStep(STEPS.PRODUCTS);
  }, []);
  const handleProceedToCheckout = (0, _react.useCallback)(details => {
    const kind = details?.kind ?? 'qr';
    const isReceipt = kind === 'receipt';
    const isSuccess = kind === 'success' || isReceipt;
    setCheckoutPresentation({
      mode: isReceipt ? 'receipt' : isSuccess ? 'success' : 'qr',
      paymentLink: details?.paymentLink ?? details?.checkoutUrl ?? '',
      receiptUrl: details?.receiptUrl ?? '',
      commandId: details?.commandId ?? '',
      paymentIntentId: details?.paymentIntentId ?? ''
    });
    if (isSuccess || isReceipt) {
      onSubmitOrder?.({
        status: 'paid',
        newcactusReference: details?.newcactusReference,
        consumptionType,
        cart
      });
    }
    setStep(STEPS.QR_CODE);
    logEvent?.({
      type: 'command_proceed_to_checkout',
      cell_id: rest.id,
      add_datas: {
        details
      }
    });
  }, [cart, consumptionType, onSubmitOrder, logEvent, rest.id]);
  const consumptionIcons = CONSUMPTION_ICONS[templateVariant] || CONSUMPTION_ICONS.default;
  const wrapperClassName = ['command-cell-kiosk', templateVariant !== 'default' && `command-cell-kiosk--${templateVariant}`, `command-cell-kiosk--step-${step}`, className].filter(Boolean).join(' ');
  const stepIndicator = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "command-kiosk__steps",
    "aria-label": "\xC9tapes de commande",
    children: [STEPS.CONSUMPTION, STEPS.PRODUCTS, STEPS.RECAP, STEPS.QR_CODE].map(s => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: `command-kiosk__step ${step >= s ? 'command-kiosk__step--active' : ''} ${step === s ? 'command-kiosk__step--current' : ''}`,
      children: [s, ". ", STEP_LABELS[s]]
    }, s))
  });
  const formatCartLineName = item => {
    let name = item.productName;
    if (item.optionLabels?.length) name += ` (${item.optionLabels.join(', ')})`;
    if (item.removedLabels?.length) name += ` [sans ${item.removedLabels.join(', ')}]`;
    return name;
  };
  if (step === STEPS.CONSUMPTION) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: wrapperClassName,
      style: kioskStyle,
      "data-scale": scaleFactor,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "command-kiosk__consumption",
        children: [stepIndicator, /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__consumption-title",
          children: labels.consumption_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "command-kiosk__consumption-choices",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__consumption-btn",
            onClick: () => handleConsumptionChoice('sur_place'),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-icon",
              children: consumptionIcons.sur_place
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-label",
              children: labels.on_site_label
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__consumption-btn",
            onClick: () => handleConsumptionChoice('emporter'),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-icon",
              children: consumptionIcons.emporter
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-label",
              children: labels.takeaway_label
            })]
          })]
        })]
      })
    });
  }
  if (step === STEPS.PRODUCTS) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: wrapperClassName,
      style: kioskStyle,
      "data-scale": scaleFactor,
      children: [detailItem && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandProductModal.default, {
        name: detailItem.name,
        subtitle: [detailItem.categoryName, detailItem.subsectionName].filter(Boolean).join(' · '),
        description: detailItem.description,
        imageUrl: detailItem.image_url || detailItem.image || detailItem.photo_url || '',
        uri_transformer: uri_transformer,
        sections: [(detailItem.option_groups ?? []).length ? {
          title: 'Options',
          items: detailItem.option_groups.map(group => group.name)
        } : null, (detailItem.removable ?? []).length ? {
          title: 'Peut être servi sans',
          items: detailItem.removable.map(ingredient => ingredient.name)
        } : null].filter(Boolean),
        prices: [{
          id: 'base',
          label: 'Prix',
          formatted: formatPrice(Number(detailItem.price) || 0)
        }],
        addLabel: labels.add_to_cart_label,
        customizeLabel: "Personnaliser",
        onCustomize: (0, _newcactusMenuUtils.itemNeedsCustomization)(detailItem) ? () => {
          setCustomizingItem(detailItem);
          setDetailItem(null);
        } : undefined,
        onAdd: (_price, quantity) => {
          addCartLine({
            menuItemId: detailItem.id,
            productName: detailItem.name,
            unitPrice: Number(detailItem.price) || 0,
            quantity,
            optionIds: [],
            removedIngredientIds: [],
            optionLabels: [],
            removedLabels: [],
            notes: '',
            categoryName: detailItem.categoryName
          });
          setDetailItem(null);
        },
        onClose: () => setDetailItem(null)
      }), customizingItem && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewCactusItemModal.default, {
        item: customizingItem,
        currency: currency,
        labels: labels,
        onClose: () => setCustomizingItem(null),
        onConfirm: line => {
          addCartLine(line);
          setCustomizingItem(null);
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `command-kiosk__inner ${cart.length > 0 ? 'command-kiosk__inner--cart-open' : ''}`,
        children: [stepIndicator, /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
          className: "command-kiosk__header",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__back",
            onClick: resetOrder,
            children: ["\u2190 ", consumptionType === 'sur_place' ? labels.on_site_label : labels.takeaway_label]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            className: "command-kiosk__title",
            children: labels.products_title
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "command-kiosk__cart-badge",
            "data-visible": cartCount > 0,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__cart-count",
              children: cartCount
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: "command-kiosk__cart-label",
              children: ["article", cartCount !== 1 ? 's' : '']
            })]
          })]
        }), menuLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "command-kiosk__menu-loading",
          children: "Chargement du menu\u2026"
        }), menuError && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "command-kiosk__menu-error",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            role: "alert",
            children: menuError
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: "command-kiosk__retry",
            onClick: () => void loadMenuData(),
            children: "R\xE9essayer"
          })]
        }), !menuLoading && !menuError && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "command-kiosk__tabs",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: `command-kiosk__tab ${selectedCategoryId === null ? 'command-kiosk__tab--active' : ''}`,
            onClick: () => setSelectedCategoryId(null),
            children: labels.all_products_tab
          }), categories.map(cat => /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: `command-kiosk__tab ${selectedCategoryId === cat.id ? 'command-kiosk__tab--active' : ''}`,
            onClick: () => setSelectedCategoryId(selectedCategoryId === cat.id ? null : cat.id),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__tab-name",
              children: cat.name
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__tab-count",
              children: cat.count
            })]
          }, cat.id))]
        }), !menuLoading && !menuError && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "command-kiosk__products",
          children: [filteredItems.map((item, index) => {
            const isAdded = addedId === item.id;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
              className: `command-kiosk__card ${isAdded ? 'command-kiosk__card--added' : ''}`,
              style: {
                animationDelay: `${index * 0.04}s`
              },
              onClick: () => handleItemClick(item),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "command-kiosk__card-image-wrap",
                children: item.image_url || item.image || item.photo_url ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: uri_transformer(item.image_url || item.image || item.photo_url),
                  alt: "",
                  className: "command-kiosk__card-image"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "command-kiosk__card-placeholder",
                  children: "\uD83C\uDF7D\uFE0F"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "command-kiosk__card-body",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "command-kiosk__card-subsection",
                  children: item.subsectionName || '\u00a0'
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "command-kiosk__card-name",
                  children: item.name
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "command-kiosk__card-footer",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: "command-kiosk__card-price",
                    children: formatPrice(Number(item.price) || 0)
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "command-kiosk__card-cta",
                    onClick: event => {
                      event.stopPropagation();
                      setDetailItem(item);
                    },
                    children: labels.details_label
                  })]
                })]
              })]
            }, `${item.categoryId}-${item.id}-${item.subsectionName ?? ''}`);
          }), filteredItems.length === 0 && !menuLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "command-kiosk__menu-empty",
            children: "Aucun plat dans cette cat\xE9gorie."
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("aside", {
          className: `command-kiosk__cart ${cart.length > 0 ? 'command-kiosk__cart--open' : ''}`,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "command-kiosk__cart-header",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__cart-title",
              children: labels.cart_title
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__cart-total",
              children: formatPrice(cartTotal)
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
            className: "command-kiosk__cart-list",
            children: cart.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              className: "command-kiosk__cart-item",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "command-kiosk__cart-item-info",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "command-kiosk__cart-item-name",
                  children: formatCartLineName(item)
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  className: "command-kiosk__cart-item-price",
                  children: [formatPrice(item.unitPrice), " \xD7 ", item.quantity]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "command-kiosk__cart-item-actions",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  className: "command-kiosk__cart-qty-btn",
                  onClick: () => updateQuantity(index, -1),
                  children: "\u2212"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "command-kiosk__cart-qty",
                  children: item.quantity
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  className: "command-kiosk__cart-qty-btn",
                  onClick: () => updateQuantity(index, 1),
                  children: "+"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  className: "command-kiosk__cart-remove",
                  onClick: () => removeFromCart(index),
                  children: "\xD7"
                })]
              })]
            }, item.lineKey))
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__cart-validate",
            disabled: cart.length === 0,
            onClick: () => setStep(STEPS.RECAP),
            children: [labels.validate_order_prefix, " \xB7 ", formatPrice(cartTotal)]
          })]
        })]
      })]
    });
  }
  if (step === STEPS.RECAP) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: wrapperClassName,
      style: kioskStyle,
      "data-scale": scaleFactor,
      children: [stepIndicator, /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewCactusCartValidation.default, {
        cart: cart,
        cartTotal: cartTotal,
        projectId: projectId,
        currency: currency,
        ncConfig: ncConfig,
        userDatas: {
          consumption_type: consumptionType
        },
        labels: labels,
        paymentMethod: newcactusPaymentMethod,
        onBack: () => setStep(STEPS.PRODUCTS),
        onProceedToCheckout: handleProceedToCheckout
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: wrapperClassName,
    style: kioskStyle,
    "data-scale": scaleFactor,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "command-kiosk__qrcode",
      children: [stepIndicator, checkoutPresentation.mode === 'success' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-kiosk__terminal-success-icon",
          "aria-hidden": true,
          children: "\u2713"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__qrcode-title",
          children: labels.payment_success_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "command-kiosk__qrcode-terminal-msg",
          children: labels.payment_success_message
        })]
      }) : checkoutPresentation.mode === 'receipt' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-kiosk__terminal-success-icon",
          "aria-hidden": true,
          children: "\u2713"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__qrcode-title",
          children: labels.payment_success_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "command-kiosk__qrcode-terminal-msg",
          children: "Commande enregistr\xE9e. Votre re\xE7u fiscal est disponible ci-dessous."
        }), checkoutPresentation.receiptUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          href: checkoutPresentation.receiptUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "command-kiosk__receipt-link",
          children: "Voir le re\xE7u RRA"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__qrcode-title",
          children: labels.qr_code_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-kiosk__qrcode-wrap",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: `https://api.qrserver.com/v1/create-qr-code/?size=${QR_CODE_SIZE}x${QR_CODE_SIZE}&data=${encodeURIComponent(checkoutPresentation.paymentLink)}&bgcolor=ffffff&color=1a1a2e`,
            alt: "QR Code paiement",
            className: "command-kiosk__qrcode-img",
            width: QR_CODE_SIZE,
            height: QR_CODE_SIZE
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "command-kiosk__qrcode-total",
        children: [labels.total_prefix, " : ", formatPrice(cartTotal)]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "command-kiosk__qrcode-back",
        onClick: resetOrder,
        children: labels.new_order_label
      })]
    })
  });
};
var _default = exports.default = CommandKioskNewCactusCore;